'use client';

import type { ReactNode } from 'react';
import Image from 'next/image';
import { Modal } from '@mokoboko/components';

import { mergeClassNames } from '@/lib/utils';

export const PatternModalHeader = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <Modal.Header
    className={mergeClassNames(
      'relative flex flex-col items-center border-none px-5 py-6 text-center',
      className
    )}
  >
    <Image
      src="/images/modal-background-pattern-v2.svg"
      alt=""
      fill
      priority
      sizes="100vw"
      className="pointer-events-none select-none object-cover"
      aria-hidden
    />
    {children}
  </Modal.Header>
);
